import React, { FunctionComponent, ComponentType, Fragment } from 'react';
import Helmet from 'react-helmet';
import QuickLinksContainer from '../containers/Dashboard/QuickLinksContainer';
import HeaderBanner from '../presentational/HeaderBanner/HeaderBanner';
import ErrorBoundary from '../presentational/Error/ErrorBoundary';
import { BannerItem } from '../../routing/util/HeaderBannerRouteMapper';

interface Props {
	Component: ComponentType;
	bannerItem?: BannerItem;
	showQuickLinks: boolean;
	showBanner: boolean;
	headerTitle: string;
}

const PageLayout: FunctionComponent<Props> = ({
	Component,
	showBanner,
	showQuickLinks,
	bannerItem,
	headerTitle,
}) => {
	return (
		<Fragment>
			{showBanner && bannerItem && (
				<React.Fragment>
					<Helmet>
						<title>{headerTitle}</title>
					</Helmet>
					<HeaderBanner
						title={bannerItem.title}
						breadcrumbs={bannerItem.breadcrumbs}
					/>
				</React.Fragment>
			)}
			<ErrorBoundary>
				<Component />
			</ErrorBoundary>
			{showQuickLinks && <QuickLinksContainer />}
		</Fragment>
	);
};

export default PageLayout;
